import {MouseEvent, MouseEventHandler, useState} from 'react';
import {Avatar, Box, Button, Menu, MenuItem, Skeleton} from '@mui/material';
import {useAuthStore, useLoginClickHandler} from './authStore';
import LogoutIcon from '@mui/icons-material/Logout';
import {User} from "../api/Model";
import {cachedImageStore} from "../api/CachedImageStore";
import {Loading} from "../components/loading-data/LoadingData";


function LoginUserPic({user, onClick}: {
    user: User,
    onClick: MouseEventHandler,
}) {
    const avatarUrl = cachedImageStore.get(user ? `/me/avatar/${user.id}` : undefined);

    return (
        <Loading
            loading={
                <Skeleton variant="circular">
                    <Avatar/>
                </Skeleton>
            }
            value={avatarUrl}
        >{avatarUrl =>
            <Avatar
                src={avatarUrl}
                alt={user.name}
                sx={{cursor: 'pointer'}}
                onClick={onClick}
            >
                {user.name ? user.name.charAt(0).toUpperCase() : ''}
            </Avatar>
        }</Loading>
    );
}

export default function Login() {
    // Use the auth store instead of local state
    const authStore = useAuthStore();
    const user = authStore.user;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleLogin = useLoginClickHandler(authStore)


    const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        authStore.logout();
        handleMenuClose();
    };

    return (
        <Box>
            {user ? (
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <LoginUserPic user={user} onClick={handleMenuOpen}/>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem onClick={handleLogout}>
                            <LogoutIcon sx={{mr: 1}} fontSize="inherit" color="inherit"/>
                            Logout
                        </MenuItem>
                    </Menu>
                </Box>
            ) : (
                <Button color="inherit" onClick={handleLogin}>
                    Sign in
                </Button>
            )}
        </Box>
    );
}
